
//门店名称 联系人 联系电话 公司地址 有效期
const columnList: Array<any> = [
    {
        prop: "name",
        label: "名称",
        width: 200,
    },
    {
        prop: "order_status",
        label: "排序",
        width: 200,
    }
];

import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch
} from "vue";
import { useRoute, useRouter } from 'vue-router'
import {getframeworkList, getPartnerList, getPositionManageList, permissionList} from "@/api/http";
import {column} from "@/assets/types/common";
import axios from "axios";
import { Request } from "@/api/request";


export default defineComponent({
    name: "positionManagement",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["仓位管理"]);
        let pageSize = ref(10),
            currentPage = ref(1),
            total = ref(0),
            tableData = ref([] as Array<any>),
            loading = ref(true),
            roleList = ref({} as any),
            headClass = inject("headClass"),
            dialog_model = ref(""),
            formRef = ref(null),
            form = ref({} as any),
            dialog_index = ref(0),
            screenParameter: any = {
                page: currentPage.value,
                pagesize: pageSize.value,
            },
            // 切换每页数量大小
            handleSizeChange = (size: number): void => {
                pageSize.value = size;
                getTableData();
            },
            // 切换分页
            handleCurrentChange = (page: number): void => {
                currentPage.value = page;
                getTableData();
            },
            getTableData = (): void => {
                loading.value = true;
                let mydata = {
                    type:1,
                    role_name:'position_manage',
                };
                permissionList(mydata).then((res:any)=>{
                    roleList.value = res?.content?.list || 0;
                });
                screenParameter['page'] = currentPage.value
                screenParameter['pagesize'] = pageSize.value
                getPositionManageList({...screenParameter}).then((res:any)=>{
                    tableData.value = res?.content?.list || [];
                    total.value = res.content.total;
                    loading.value = false;
                });
            },
            _upState =(id: number, status: number) => {
                Request.axiosInstance({
                    url:　'adminapi/PositionManage/upState',
                    data: {
                        id: id,
                        status:status
                    }
                }).then((res: any) => {
                    res.status == 202 && getTableData()
                });
            },
            _submitForm = () => {
                (formRef.value as any).validate((valid: boolean) => {
                    if (!valid) return
                    Request.axiosInstance({
                        url:  dialog_model.value == 'edit' ? 'adminapi/PositionManage/edit' :  'adminapi/PositionManage/create' ,
                        data: form.value
                    }).then((res: any) => {
                        res.status == 202 && (getTableData(), dialog_model.value ='')
                    })
                })
            }
        
        
        
        onMounted(() => {
            
            
            
            
            
            getTableData()
        });
        
        
        watch(dialog_model, (newval, oldval) => {
            if (formRef.value){
                (formRef.value as any).resetFields();
            }
            if(newval == 'add')
            {
                form.value ={
                    name: '',
                    order_status: '',
                }
                
            }
            else if(newval == 'edit')
            {
                form.value ={
                    id:tableData.value[dialog_index.value].id,
                    name:tableData.value[dialog_index.value].name,
                    order_status: tableData.value[dialog_index.value].order_status,
                }
            }
        })
        
        return {
            columnList,
            tableData,
            loading,
            headClass,
            screenParameter,
            _upState,
            dialog_model,
            dialog_index,
            form,
            formRef,
            _submitForm,
            roleList,
            handleCurrentChange,
            handleSizeChange,
            currentPage,
            pageSize,
            total
        };
    },
});

